import styled from 'styled-components';
import { ModalContainer, ModalHeader } from '../FormModal/styles';
import { colors } from 'styles/colors';

export const DeleteModalContainer = styled(ModalContainer)`
  gap: 16px;
  width: 390px;

  @media (max-width: 768px) {
    height: auto;
    width: 100%
    margin: 0;
    margin-top: auto;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;

export const DeleteModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  & > p {
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 180%;
    color: ${colors.text['sub-500']};
  }

  & > div {
    display: flex;
    gap: 8px;
  }

  & > div > button {
    height: 33px;
  }

  @media (max-width: 768px) {
    & > div {
      flex-direction: column-reverse;
    }

    & > div > button {
      width: 100%;
      height: 52px;
      font-size: 18px;
      border-radius: 8px;
    }
  }
`;

export const DeleteModalHeader = styled(ModalHeader)`
  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & > div > h3 {
    margin: 0;
  }
`;
